// register plugins
import '@/plugins/app-config';
import '@/plugins/vue-notifications';
import '@/plugins/vue-qrcode-reader';
import '@/plugins/vue-qriously';
import '@/plugins/vuetify-loader';
import '@babel/polyfill';
import VeeValidate from 'vee-validate';
import Vue from 'vue';
import App from './App.vue';
import './plugins/class-component-hooks';
import { Vuelux } from './plugins/vuelux/index';
import './registerServiceWorker';
import Router from './router';
import Store from './store/index';

Vue.config.productionTip = false;
Vue.use(Vuelux);
Vue.use(VeeValidate);

new Vue({
  $_veeValidate: {
    validator: 'new'
  },
  router: Router,
  store: Store,
  render: (h) => h(App),
}).$mount('#app');
